import { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

const TasksRootComponent: FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <div>
      {children || <Outlet />}
    </div>
  );
};

export default TasksRootComponent;
